import React from 'react';

export const Status = ({ isNew, status, hideText, rfqServiceType }) => {
    return (
        <div>
            {
                isNew && 
                <span> { status.statusText } </span>
            }
            {
                !isNew && status && <div> 
                   <span className="wt-22-5 ht-22-5 lh-22-5p tCenter fs-14 fBold inBlock mr-5" style={{backgroundColor: status.colorCode}}>{status.count || status.statusText }</span> 
                    {
                        !hideText && <span> {status.statusText || '-'}</span>
                    }
                     
                </div>
            }
        </div>
    )
}